export const languageMap = {
  "en-es": "es-US",
  en: "en-US",
  "pl-PL": "pl-PL",
  "fr-FR": "fr-FR",
  "ru-RU": "ru-RU",
};
